const TRANSFER_ENDPOINT = import.meta.env.VITE_TRANSFER_METRICS_ENDPOINT;

type Phase = 'upload' | 'processing' | 'total';

type MetricPayload = {
  phase: Phase;
  durationMs: number;
  styleId?: string;
  tokenType?: 'device' | 'user';
  timestamp?: string;
};

export async function recordTransferMetric(payload: MetricPayload) {
  const body = {
    ...payload,
    timestamp: payload.timestamp ?? new Date().toISOString()
  };

  if (!TRANSFER_ENDPOINT) {
    console.info('[transfer-metric]', body);
    return;
  }

  try {
    await fetch(TRANSFER_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  } catch (error) {
    console.warn('Failed to send transfer metric', error, body);
  }
}
